module.exports = __webpack_public_path__ + "static/media/qrcode.7a6ccd18.png";